import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import RestrictAccess from "../RestrictedAccess";
import AuthContainer from "../../../store/container/AuthContainer";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";

const requireAuth = (Component: any, allowedRoles: any = []) => {
  const Authentication = (props: any) => {
    useEffect(() => {
      const { authenticated, history } = props;
      if (!authenticated && history.location.pathname !== AppRoutes.LOGIN) {
        const from = {
          pathname: history.location.pathname,
          search: history.location.search,
        };
        const returnTo = `${history.location.pathname}${history.location.search}`;
        return history.push({
          pathname: AppRoutes.LOGIN,
          search: `?returnUrl=${encodeURIComponent(returnTo)}`,
          state: { from },
        });
      }
    }, [props]);

    if (allowedRoles.length) {
      const { user } = props;
      return allowedRoles.includes(user.role) ? (
        <Component {...props} />
      ) : (
        <RestrictAccess />
      );
    }
    return <Component {...props} />;
  };
  return withRouter(AuthContainer(Authentication));
};

export default requireAuth;
